/* eslint-disable max-lines-per-function */
import { createElement } from "react";
import { createReactRoot } from "common/react/create-react-root";
import { IntlProvider } from "react-intl";
import { messages } from "intl/messages";
import { dtfStore } from "components/jiffy/react-product-details-dtf/store";
import DesignLibraryModal from "./DesignLibraryModal.vue";

const CONTAINER_ID = "design-library-modal-container";
const DESKTOP_PER_PAGE = 36;

class DesignLibraryModalManager {
  #containerId = CONTAINER_ID;

  get #$container() {
    return document.getElementById(this.#containerId);
  }

  get #state() {
    const dataset = this.#$container!.dataset as any;
    return {
      businessLine: dataset.businessLine,
      catalogNumber: dataset.catalogNumber,
      singleSelectionMode: dataset.singleSelectionMode === "true",
      pdpType: dataset.pdpType,
      reorderEnabled: dataset.reorderEnabled === "true"
    };
  }

  constructor() {
    const $container = this.#ensureContainer();
    const state = this.#state;

    const locale = document.documentElement.lang || "en-US";

    const root = createReactRoot($container, "Design Library Modal");
    root.render(
      createElement(
        IntlProvider,
        { locale, defaultLocale: "en-US", messages },
        createElement(DesignLibraryModal, {
          index: 0,
          singleSelectionMode: !!state.singleSelectionMode,
          reorderEnabled: !!state.reorderEnabled
        })
      )
    );

    DesignLibraryModalManager.seedDtfStore(state);
  }

  #ensureContainer() {
    let $container = this.#$container;
    if (!$container) {
      $container = document.createElement("div");
      $container.id = this.#containerId;
      document.body.appendChild($container);
    }
    return $container;
  }

  static seedDtfStore(
    state: {
      catalogNumber?: string;
      pdpType?: string;
      businessLine?: string;
      reorderEnabled?: boolean;
    } = {}
  ) {
    const store = dtfStore as Record<string, unknown> & {
      setCatalogNumber: (v: string) => void;
      setPdpType: (v: string) => void;
      setBusinessLine: (v: string) => void;
      setReorderEnabled: (v: boolean) => void;
      setArtworkHistory: (v: unknown[]) => void;
      setArtworkHistoryPagination: (v: { page: number; perPage: number }) => void;
    };

    if (state.catalogNumber !== undefined) store.setCatalogNumber(state.catalogNumber);
    if (state.pdpType !== undefined) store.setPdpType(state.pdpType);
    if (state.businessLine !== undefined) store.setBusinessLine(state.businessLine);

    store.setReorderEnabled(!!state.reorderEnabled);
    store.setArtworkHistory([]);
    store.setArtworkHistoryPagination({
      page: 1,
      perPage: DESKTOP_PER_PAGE
    });
  }
}

// eslint-disable-next-line import/no-default-export
export default DesignLibraryModalManager;
